<template>
    <ion-item :class="{ transparent: transparent, 'ion-no-padding': hasIcon }">
        <ion-label class="textbox-label" :position="hasIcon == 'true' ? 'stacked' : 'floating'">{{ label }}</ion-label>
        <ion-textarea
            v-if="rows > 1"
            :placeholder="placeholder"
            :type="inputType"
            @ionChange="handleChange"
            ref="input"
            :rows="rows"
            :value="defaultValue"
        >
        </ion-textarea>
        <ion-input v-else :placeholder="placeholder" :type="inputType" ref="input" @ionChange="handleChange" :value="defaultValue">
            <img v-if="hasIcon" :src="iconSource" class="ion-float-start icon-img-xs ion-margin-end" />
        </ion-input>
        <p v-if="error" class="error-message">{{ error }}</p>
    </ion-item>
</template>

<script>
export default {
    name: 'TextBox',
    props: ['placeholder', 'label', 'inputType', 'error', 'transparent', 'optionId', 'rows', 'hasIcon', 'defaultValue'],
    data() {
        return {
            iconSource: require('@/assets/icon-images/cancel.png'),
            iconColor: 'danger'
        }
    },
    mounted() {
        if (this.defaultValue) {
            this.iconSource = require('@/assets/icon-images/tick.png')
            this.iconColor = 'primary'
        }
    },
    methods: {
        handleChange(e) {
            if (this.optionId === undefined) {
                this.$emit('onChange', e.detail.value)
            } else if (this.hasIcon) {
                if (this.$refs.input.children[1].value != '') {
                    this.iconSource = require('@/assets/icon-images/tick.png')
                    this.iconColor = 'primary'
                } else {
                    this.iconSource = require('@/assets/icon-images/cancel.png')
                    this.iconColor = 'danger'
                }
                this.$emit('onChange', {
                    data: e.detail.value,
                    optionId: this.optionId
                })
            } else {
                this.$emit('onChange', {
                    data: e.detail.value,
                    optionId: this.optionId
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.textbox-label {
    color: #919191;
}

.transparent {
    --background: transparent;
}

@media (min-width: 768px) {
    ion-label {
        font-size: 100% !important;
    }
}

@media (min-width: 1200px) {
    ion-item {
        --background: transparent;
    }
}
</style>
